<template>
    <div class="contacts">
        <p v-if="data.email"><img src="@/assets/images/contacts/email.png" /> {{ data.email }}</p>
        <p v-if="data.address"><img src="@/assets/images/contacts/map.png" /> {{ data.address.value }}</p>
        <p v-if="data.placeOfBirth"><img src="@/assets/images/contacts/map.png" /> {{ data.placeOfBirth.value }}</p>
        <p v-if="data.telegram"><img src="@/assets/images/social/color/telegram.svg" /> {{ data.telegram }}</p>
        <p v-if="data.vk"><img src="@/assets/images/social/color/vk.svg" /> {{ data.vk }}</p>
        <p v-if="data.zen"><img src="@/assets/images/social/color/dzen.svg" /> {{ data.zen }}</p>
        <p v-if="data.ok"><img src="@/assets/images/social/color/ok.svg" /> {{ data.ok }}</p>
        <p v-if="data.youtube"><img src="@/assets/images/social/color/yt.svg" /> {{ data.youtube }}</p>
        <p v-if="data.tikTok"><img src="@/assets/images/social/color/tiktok.svg" /> {{ data.tikTok }}</p>
        <p v-if="data.yappy"><img src="@/assets/images/social/color/yappy.svg" /> {{ data.yappy }}</p>
        <p v-if="data.rutube"><img src="@/assets/images/social/color/rutube.svg" /> {{ data.rutube }}</p>
        <p v-if="data.tenchat"><img src="@/assets/images/social/color/tenchat.svg" /> {{ data.tenchat }}</p>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAboutContacts",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.contacts {
  display: flex;
  flex-direction: column;
  gap: rem(6);
  p {
    display: flex;
    align-items: center;
    gap: rem(6);
    img {
      height: rem(20);
    }
  }
}
</style>